<template>
  <modal
    :active="true"
    class="dispute-rename-attachments"
    size="medium"
    tertiary-button-label="No"
    primary-button-label="Yes"
    @onClose="onClose()"
    @onConfirm="onConfirm()">
    <template #header>
      <p>Alert!</p>
    </template>
    <template #content>
      <div
        v-for="(errorMessage, index) in errorMessageFileNameList"
        :key="`${index}`"
        class="dispute-rename-attachments__container">
        <div
          v-if="errorMessage"
          class="dispute-rename-attachments__container__validation-msg">
          {{ errorMessage }}
        </div>
      </div>
    </template>
  </modal>
</template>

<script>
export default {
  name: "DisputeRenameAttachmentsModal",
  props: {
    filesWithSameName: {
      type: Array,
      required: true,
    },
    errorMessageFileNameList: {
      type: Array,
      required: true,
    },
  },
  methods: {
    onClose() {
      this.$emit("onModalClose");
    },
    onConfirm() {
      this.$emit("scanFilesToUpload", this.filesWithSameName, null, true);
    },
  },
};
</script>

<style lang="scss">
.dispute-rename-attachments {
  .modal--medium {
    height: fit-content;
    width: 800px;
  }
  &__container {
    padding: 0px 8px;
    &__validation-msg {
      padding-bottom: 8px;
    }
  }
}
</style>
